import useHearingCouncilsLink from './use-hearing-councils-links';
import ReactPlayer from 'react-player';
import { Card, IconButton, MenuItem, Stack, Typography } from '@mui/material';
import TextMaxLine from 'src/components/text-max-line';
import Iconify from 'src/components/iconify';
import CustomPopover from 'src/components/custom-popover';
import DeleteDialog from 'src/sections/dialogs/delete/DeleteDialog';

const HearingCouncilsLinkCard = ({ hearing_council_link }: any) => {
  const { popover, deleteDialog, CONTEXT_ITEMS, deleteHearingCouncilLink, isDeleting } =
    useHearingCouncilsLink();

  return (
    <>
      <Card
        sx={{
          p: 3,
          backgroundColor: 'background.paper',
          width: '100%',
          height: '100%',
        }}
      >
        <Stack
          alignItems="center"
          direction="row"
          justifyContent="space-between"
          spacing={1}
          sx={{ pb: 2 }}
        >
          <TextMaxLine line={1}>
            <Typography variant="subtitle1">{hearing_council_link.title}</Typography>
          </TextMaxLine>
          <IconButton
            onClick={popover.onOpen}
            sx={{
              width: 40,
              height: 40,
              ...(popover.open && {
                bgcolor: 'action.selected',
              }),
            }}
          >
            <Iconify icon="qlementine-icons:menu-dots-16" sx={{ borderRadius: 0.65, width: 28 }} />
          </IconButton>
        </Stack>
        <Stack alignItems="center" direction="row" spacing={1} sx={{ height: 300 }}>
          <ReactPlayer url={hearing_council_link.link} width="100%" height="100%" controls />
        </Stack>

        <DeleteDialog
          idWord="id"
          id={hearing_council_link.id}
          isDeleting={isDeleting}
          open={deleteDialog.value}
          onClose={deleteDialog.onFalse}
          mutate={deleteHearingCouncilLink}
        />
        <CustomPopover open={popover.open} onClose={popover.onClose}>
          {CONTEXT_ITEMS.map((iconBtn) => (
            <MenuItem key={iconBtn.icon} onClick={iconBtn.onClick}>
              <Stack alignItems="center" direction="row">
                <Iconify icon={iconBtn.icon} color={iconBtn.color} />
                <Typography color={iconBtn.color} variant="caption">
                  {iconBtn.label}
                </Typography>
              </Stack>
            </MenuItem>
          ))}
        </CustomPopover>
      </Card>
    </>
  );
};

export default HearingCouncilsLinkCard;
